let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dPdkf")).then(() => parcelRequire('4behf'));